module.exports = __webpack_public_path__ + "media/images/promotions/cards/fate-movie-4398f426ce78a740ddeb75ece072d672.svg";